// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".firmador-select[data-v-3aff4406] {\n  cursor: pointer;\n  padding: 20px 30px;\n  border-radius: 5px;\n  border: 1px solid #cacaca;\n}", ""]);
// Exports
module.exports = exports;
